import React, { useState } from "react";
import {
  CButton,
  CModal,
  CModalTitle,
  CModalHeader,
  CModalBody,
  CModalFooter,
  CSpinner,
} from "@coreui/react";

const DeleteProject = ({ handleDelete, onClose, setToast }) => {
  const [deleting, setDeleting] = useState(false);
  return (
    <CModal
      onClose={onClose}
      size="lg"
      backdrop="static"
      alignment="center"
      scrollable
      visible
    >
      <CModalHeader>
        <CModalTitle>Confirmar eliminação</CModalTitle>
      </CModalHeader>
      <CModalBody>
        <p>Tem a certeza que pretende eliminar o projeto</p>
        <p className="text-danger mb-0">
          Esta ação é irreversível e apagará todos os dados associados.
        </p>
      </CModalBody>
      <CModalFooter className="justify-content-end">
        <CButton color="secondary" variant="outline" onClick={onClose}>
          Cancelar
        </CButton>
        <CButton
          color="danger"
          onClick={async () => {
            setDeleting(true);
            try {
              await handleDelete();
            } finally {
              setDeleting(false);
            }
          }}
          disabled={deleting}
        >
          {deleting && <CSpinner size="sm" className="me-2" />}
          Eliminar
        </CButton>
      </CModalFooter>
    </CModal>
  );
};

export default DeleteProject;
